// extracted by mini-css-extract-plugin
export default {"cautionBox":"c8-z"};